// extracted by mini-css-extract-plugin
export var gif = "_du-0";